import { Component, ChangeDetectionStrategy, input } from '@angular/core'
import { MetricDetailed } from '@features/metric-detail/models/metric-detail.models'
import { TranslatePipe } from '@ngx-translate/core'
import { DecimalPipe } from '@angular/common'

@Component({
  selector: 'mcm-metric-detail-item',
  templateUrl: './metric-detail-item.component.html',
  styleUrls: ['./metric-detail-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, DecimalPipe]
})
export class MetricDetailItemComponent {
  readonly item = input.required<MetricDetailed>()
  readonly lang = input.required<string>()
}
